module.exports = __webpack_public_path__ + "static/img/M3s.aa602ace.png";